/* kb-sections.js: de secties uit het shopontwerp die meer zijn dan één carrousel.
   - [data-kb-routine]  routine in 5 stappen (B1), /recs/routine
   - [data-kb-tabs]     trending-tabs met mini-foto's en paginapunten (B3), /recs per tab
   - [data-kb-months]   trending per maand met rangnummers (B3), /recs/months
   - [data-kb-tiers]    staffelbalk in de cart drawer met confetti (B2)
   Vereist kb-config (window.KBREC) en kb-recs.js (window.KBRecs). Zonder API verbergen de secties zich. */
(function () {
  'use strict';
  var C = window.KBREC;
  if (!C || !C.api) return;
  var R = function () { return window.KBRecs; };
  var TIMEOUT = 1500;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function prefix() { return C.localePrefix === '/' ? '' : (C.localePrefix || ''); }
  function visitor() { return window.KBTrack ? window.KBTrack.visitor() : null; }
  function cartIds() { return ((window.KBTrack ? window.KBTrack.cart() : C.cart) || []).map(function (i) { return Number(i.product_id); }); }
  function track(ev) { if (window.KBTrack) window.KBTrack.track(ev); }
  function get(url) { return R().fetch(url, TIMEOUT); }
  function S(group, k, d) { var g = C.strings && C.strings[group]; return (g && g[k]) || d; }

  /* Producten in één keer toevoegen via Blockshop (drawer, teller en verzendbalk lopen mee), anders /cart/add.js. */
  function addVariants(items, opener) {
    if (!items.length) return Promise.resolve();
    var BS = window.customElements && customElements.get('cart-element');
    if (BS && typeof BS.addItems === 'function' && BS.sections) {
      return BS.addItems({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items, sections: BS.sections }) }, opener || null);
    }
    return fetch(prefix() + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function firstVariant(p) {
    return fetch(prefix() + '/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (prod) { var v = (window.KBPickVariant || (function (prod) { var vs = (prod.variants || []).filter(function (x) { return x.available; }); vs.sort(function (a, b) { return (b.price || 0) - (a.price || 0); }); return vs[0]; }))(prod); return v ? v.id : null; });
  }

  /* Impressie bij 50 procent zichtbaar, één keer per antwoord. */
  function impression(el, data, ids) {
    if (!window.KBTrack || !('IntersectionObserver' in window)) return;
    if (el.__kbSeen === data.request_id) return;
    if (el.__kbIo) el.__kbIo.disconnect();
    var io = el.__kbIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio >= 0.5 && el.__kbSeen !== data.request_id) {
          el.__kbSeen = data.request_id; io.disconnect();
          track({ type: 'impression', placement: data.placement, request_id: data.request_id, extra: { product_ids: ids } });
        }
      });
    }, { threshold: [0.5] });
    io.observe(el);
  }

  /* ---------- B1 routine ---------- */
  function initRoutine(sec) {
    var cache = {}, mode = sec.getAttribute('data-kb-mode') || 'morning', current = null;
    var list = sec.querySelector('[data-kb="steps"]');
    var q = function (k) { return sec.querySelector('[data-kb="' + k + '"]'); };
    sec.querySelectorAll('.kbr-toggle button').forEach(function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('data-mode') !== mode) { mode = b.getAttribute('data-mode'); show(); } });
    });
    function show() {
      sec.querySelectorAll('.kbr-toggle button').forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-mode') === mode)); });
      var p = cache[mode] || (cache[mode] = get(C.api + '/recs/routine?mode=' + mode + '&locale=' + C.locale + (C.product ? '&product=' + C.product.id : '') + '&prefix=' + encodeURIComponent(prefix())));
      p.then(render).catch(function () { sec.hidden = true; });
    }
    function render(data) {
      current = data;
      var steps = (data.steps || []).filter(function (s) { return s.product; });
      if (steps.length < 3) { sec.hidden = true; return; }
      list.innerHTML = steps.map(function (s, i) {
        var p = s.product, sale = p.compare_at_price && p.compare_at_price > p.price;
        return '<li class="kbr-step" style="animation-delay:' + (i * 60) + 'ms">' +
          '<div class="kbr-step__head"><span class="kbr-step__n">' + (i + 1) + '</span><span><span class="kbr-step__label">' + esc(s.label) + '</span><span class="kbr-step__hint">' + esc(s.hint) + '</span></span></div>' +
          '<a class="kbr-step__media" href="' + esc(p.url) + '" data-i="' + i + '"><img src="' + esc(p.image ? R().sized(p.image, 400) : '') + '" alt="' + esc(p.title) + '" loading="lazy"' + (p.image ? '' : ' hidden') + '></a>' +
          '<span class="kbr-step__vendor">' + esc(p.vendor || '') + '</span>' +
          '<a class="kbr-step__title" href="' + esc(p.url) + '" data-i="' + i + '">' + esc(p.title) + '</a>' +
          '<div class="kbr-step__row"><span class="kbr-step__price"><span class="kbr-step__now' + (sale ? ' is-sale' : '') + '">' + R().money(p.price) + '</span>' + (sale ? '<s>' + R().money(p.compare_at_price) + '</s>' : '') + '</span>' +
          '<a class="kbr-step__all" href="' + esc(s.all_url) + '">' + esc(s.all_label) + ' →</a></div>' +
          '<button type="button" class="kbr-step__add" data-i="' + i + '">' + esc(S('routine', 'add', 'In winkelwagen')) + '</button>' +
          '</li>';
      }).join('');
      list.querySelectorAll('a[data-i]').forEach(function (a) {
        a.addEventListener('click', function () { var i = +a.getAttribute('data-i'); clickTrack(steps[i].product, i + 1); });
      });
      list.querySelectorAll('.kbr-step__add').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-i'), p = steps[i].product;
          clickTrack(p, i + 1); b.disabled = true;
          firstVariant(p).then(function (v) { if (!v) throw new Error('uitverkocht'); return addVariants([{ id: v, quantity: 1 }], null); })
            .then(function () { cartEvent(p); b.textContent = S('routine', 'added', 'Toegevoegd ✓'); b.classList.add('is-done'); setTimeout(function () { b.disabled = false; b.textContent = S('routine', 'add_more', 'Nog een toevoegen'); b.classList.remove('is-done'); }, 2000); })
            .catch(function () { b.disabled = false; });
        });
      });
      var total = steps.reduce(function (a, s) { return a + Number(s.product.price || 0); }, 0);
      q('total').textContent = R().money(total);
      owned();
      sec.hidden = false;
      impression(sec, data, steps.map(function (s) { return s.product.id; }));
    }
    function clickTrack(p, pos) {
      if (!current || !window.KBTrack) return;
      track({ type: 'click', placement: 'pdp_routine', product_id: p.id, position: pos, request_id: current.request_id, extra: { mode: mode } });
      window.KBTrack.flush();
    }
    function cartEvent(p) {
      document.dispatchEvent(new CustomEvent('theme:cart:productAdded', { detail: { product_id: p.id, kb_placement: 'pdp_routine', kb_request_id: current && current.request_id } }));
    }
    function owned() {
      if (!current) return;
      var steps = (current.steps || []).filter(function (s) { return s.product; });
      var inCart = cartIds();
      var n = steps.filter(function (s) { return inCart.indexOf(Number(s.product.id)) >= 0; }).length;
      q('owned').textContent = S('routine', 'owned', '{n} van {total} in je tas').replace('{n}', n).replace('{total}', steps.length);
    }
    q('shop').addEventListener('click', function () {
      if (!current) return;
      var btn = q('shop'), inCart = cartIds();
      var todo = (current.steps || []).filter(function (s) { return s.product && inCart.indexOf(Number(s.product.id)) < 0; });
      if (!todo.length) return;
      btn.disabled = true;
      todo.forEach(function (s) { clickTrack(s.product, (current.steps.indexOf(s)) + 1); });
      Promise.all(todo.map(function (s) { return firstVariant(s.product); }))
        .then(function (vs) { return addVariants(vs.filter(Boolean).map(function (v) { return { id: v, quantity: 1 }; }), btn); })
        .then(function () { todo.forEach(function (s) { cartEvent(s.product); }); })
        .catch(function () {}).then(function () { btn.disabled = false; });
    });
    document.addEventListener('kb:cart', owned);
    show();
  }

  /* ---------- B3 trending-tabs ---------- */
  function initTabs(sec) {
    var listEl = sec.querySelector('[data-kb-tabs-list]');
    var tabs = [].slice.call(sec.querySelectorAll('.kbr-tab'));
    var limit = listEl.getAttribute('data-kb-limit') || '8';
    var data = {}, active = null;
    var vis = visitor();
    var loads = tabs.map(function (t) {
      var pl = t.getAttribute('data-placement');
      return get(C.api + '/recs?placement=' + pl + '&locale=' + C.locale + '&limit=' + limit + (vis ? '&visitor=' + vis : ''))
        .then(function (d) { data[pl] = d; thumbs(t, d); if (!d.products || !d.products.length) t.hidden = true; })
        .catch(function () { t.hidden = true; });
    });
    function thumbs(t, d) {
      var box = t.querySelector('[data-kb="thumbs"]');
      box.innerHTML = (d.products || []).slice(0, 3).map(function (p) { return p.image ? '<span style="background-image:url(\'' + esc(R().sized(p.image, 120)) + '\')"></span>' : ''; }).join('');
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { pick(t); }); });
    function pick(t) {
      var pl = t.getAttribute('data-placement');
      if (!data[pl]) return;
      active = pl;
      tabs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
      listEl.setAttribute('data-kb-placement', pl);
      R().render(listEl, data[pl]);
      listEl.querySelector('.kb-recs__list').scrollLeft = 0;
      pager();
    }
    var list = function () { return listEl.querySelector('.kb-recs__list'); };
    var dots = sec.querySelector('[data-kb="dots"]'), prev = sec.querySelector('[data-kb="prev"]'), next = sec.querySelector('[data-kb="next"]');
    function pages() { var l = list(); return Math.max(1, Math.round(l.scrollWidth / Math.max(1, l.clientWidth))); }
    function page() { var l = list(); return Math.round(l.scrollLeft / Math.max(1, l.clientWidth)); }
    function pager() {
      var n = pages(), i = Math.min(page(), n - 1);
      dots.innerHTML = '';
      for (var k = 0; k < n; k++) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kbr-dot' + (k === i ? ' is-on' : '');
        b.setAttribute('aria-label', S('tabs', 'page', 'Pagina') + ' ' + (k + 1));
        (function (k) { b.addEventListener('click', function () { go(k); }); })(k);
        dots.appendChild(b);
      }
      prev.disabled = i <= 0; next.disabled = i >= n - 1;
      sec.querySelector('.kbr-pager').hidden = n <= 1;
    }
    function go(k) { var l = list(); l.scrollTo({ left: k * l.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { go(Math.max(0, page() - 1)); });
    next.addEventListener('click', function () { go(Math.min(pages() - 1, page() + 1)); });
    var st = null;
    listEl.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(pager, 80); }, true);
    window.addEventListener('resize', function () { if (active) pager(); });
    Promise.all(loads).then(function () {
      var first = tabs.filter(function (t) { return !t.hidden; })[0];
      if (!first) { sec.hidden = true; return; }
      sec.hidden = false;
      pick(first);
    });
  }

  /* ---------- B3 trending per maand ---------- */
  function initMonths(sec) {
    var listEl = sec.querySelector('[data-kb-months-list]');
    var bar = sec.querySelector('[data-kb="months"]');
    var title = sec.querySelector('[data-kb="title"]');
    var count = sec.getAttribute('data-kb-count') || '6';
    var loc = C.locale === 'en' ? 'en-GB' : C.locale;
    get(C.api + '/recs/months?locale=' + C.locale + '&count=' + count + '&limit=6').then(function (d) {
      var months = d.months || [];
      if (!months.length) { sec.hidden = true; return; }
      var now = new Date(), nowKey = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
      bar.innerHTML = months.map(function (m, i) {
        var dt = new Date(m.month + '-01T12:00:00');
        var short = dt.toLocaleDateString(loc, { month: 'short' }).replace('.', '').slice(0, 3);
        var img = m.products[0] && m.products[0].image ? R().sized(m.products[0].image, 120) : '';
        return '<button type="button" class="kbr-month" role="tab" data-i="' + i + '" aria-pressed="' + (i === 0) + '">' +
          '<span class="kbr-month__short">' + esc(short) + '</span><span class="kbr-month__year">' + dt.getFullYear() + '</span>' +
          (img ? '<span class="kbr-month__thumb" style="background-image:url(\'' + esc(img) + '\')"></span>' : '') +
          (m.month === nowKey ? '<span class="kbr-month__live"><i></i>' + esc(bar.getAttribute('data-live') || 'Live') + '</span>' : '') + '</button>';
      }).join('');
      bar.querySelectorAll('.kbr-month').forEach(function (b) { b.addEventListener('click', function () { pick(+b.getAttribute('data-i')); }); });
      function pick(i) {
        var m = months[i];
        bar.querySelectorAll('.kbr-month').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-i') === i)); });
        var name = new Date(m.month + '-01T12:00:00').toLocaleDateString(loc, { month: 'long' });
        title.textContent = (title.getAttribute('data-template') || 'Top van {month}').replace('{month}', name);
        R().render(listEl, { placement: 'home_months', request_id: d.request_id + ':' + m.month, products: m.products, title: '', subtitle: '' });
        listEl.querySelectorAll('.kbr-card').forEach(function (li, k) {
          var media = li.querySelector('.kbr-card__media');
          if (media && !media.querySelector('.kbr-card__rank')) { var r = document.createElement('span'); r.className = 'kbr-card__rank'; r.textContent = String(k + 1).padStart(2, '0'); media.appendChild(r); }
        });
      }
      sec.hidden = false;
      pick(0);
    }).catch(function () { sec.hidden = true; });
  }

  /* ---------- B2 staffelbalk ---------- */
  var tierTotal = null;
  function initTiers() {
    // Drempels uit data-t1..t4 (lege of 0 overgeslagen); markeringen gelijk verdeeld van 0 tot 100%, zoals in het ontwerp.
    function tiers(el) {
      var out = [];
      [1, 2, 3, 4].forEach(function (i) {
        var t = Number(el.getAttribute('data-t' + i)) || 0;
        if (t > 0) out.push({ i: i, t: t, r: el.getAttribute('data-r' + i) || '', l: el.getAttribute('data-l' + i) || '' });
      });
      return out.sort(function (a, b) { return a.t - b.t; });
    }
    function refresh() {
      fetch(prefix() + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var total = (cart.total_price || 0) / 100;
        document.querySelectorAll('[data-kb-tiers]').forEach(function (el) { paint(el, total, cart.item_count || 0); });
        var before = tierTotal; tierTotal = total;
        var el = document.querySelector('[data-kb-tiers]');
        if (el && before !== null && total > before) {
          if (tiers(el).some(function (x) { return before < x.t && total >= x.t; })) confetti();
        }
      }).catch(function () {});
    }
    function paint(el, total, count) {
      var ts = tiers(el), n = ts.length;
      if (n < 2 || !count) { el.hidden = true; return; }
      var pos = function (k) { return k / (n - 1) * 100; };
      var pct = 0;
      if (total >= ts[n - 1].t) pct = 100;
      else for (var k = 0; k < n - 1; k++) if (total >= ts[k].t && total < ts[k + 1].t) pct = pos(k) + (total - ts[k].t) / (ts[k + 1].t - ts[k].t) * (pos(k + 1) - pos(k));
      el.querySelector('[data-kb="fill"]').style.width = pct + '%';
      var next = ts.filter(function (x) { return total < x.t; })[0];
      el.querySelector('[data-kb="text"]').textContent = !next ? el.getAttribute('data-done')
        : el.getAttribute('data-remaining').replace('{amount}', R().money(next.t - total)).replace('{reward}', next.r);
      el.querySelector('[data-kb="total"]').textContent = R().money(total);
      el.querySelectorAll('.kbr-tiers__mark, .kbr-tiers__labels span').forEach(function (m) {
        var k = -1; ts.forEach(function (x, j) { if (x.i === +m.getAttribute('data-i')) k = j; });
        if (k < 0) { m.hidden = true; return; }
        m.hidden = false;
        m.style.left = pos(k) + '%';
        m.classList.toggle('is-first', k === 0); m.classList.toggle('is-last', k === n - 1);
        m.classList.toggle('is-on', total >= ts[k].t);
        if (m.tagName === 'SPAN' && m.parentNode.classList.contains('kbr-tiers__labels')) m.textContent = ts[k].l;
      });
      // Gratis verzending voor het land van de bezoeker (data-ship uit de tabel in de theme-instellingen).
      var ship = Number(el.getAttribute('data-ship')) || 0, sh = el.querySelector('[data-kb="ship"]');
      if (sh) {
        sh.hidden = !ship;
        if (ship) {
          sh.classList.toggle('is-on', total >= ship);
          sh.querySelector('[data-kb="ship-text"]').textContent = total >= ship ? el.getAttribute('data-ship-done')
            : el.getAttribute('data-ship-remaining').replace('{amount}', R().money(ship - total));
        }
      }
      el.hidden = false;
      // Onder de eerste drempel: de upsell-kop verwijst naar het cadeau.
      var up = document.querySelector('[data-kb-placement="cart_upsell"]');
      if (up) {
        if (total < ts[0].t) { up.setAttribute('data-kb-title', el.getAttribute('data-upsell-title')); up.setAttribute('data-kb-sub', el.getAttribute('data-upsell-sub')); }
        else { up.removeAttribute('data-kb-title'); up.removeAttribute('data-kb-sub'); }
        var tt = up.querySelector('.kb-recs__title'), ss = up.querySelector('.kb-recs__subtitle');
        if (total < ts[0].t && tt) { tt.textContent = el.getAttribute('data-upsell-title'); if (ss) { ss.textContent = el.getAttribute('data-upsell-sub'); ss.hidden = false; } }
      }
    }
    if (!document.querySelector('[data-kb-tiers]')) return;
    refresh();
    document.addEventListener('kb:cart', refresh);
    window.addEventListener('theme:cart:updated', function () { setTimeout(refresh, 60); });
  }
  function confetti() {
    if (reduce) return;
    var c = document.getElementById('kbr-confetti');
    if (!c) { c = document.createElement('canvas'); c.id = 'kbr-confetti'; c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000'; document.body.appendChild(c); }
    c.width = innerWidth; c.height = innerHeight; var ctx = c.getContext('2d');
    var cols = ['#c4577a', '#f3b8c9', '#ffd166', '#141414', '#fff', '#2e7d4f'];
    var ps = []; for (var i = 0; i < 140; i++) ps.push({ x: c.width / 2 + (Math.random() - .5) * c.width * .4, y: c.height * .35, vx: (Math.random() - .5) * 14, vy: -Math.random() * 14 - 4, r: 4 + Math.random() * 5, a: Math.random() * Math.PI, va: (Math.random() - .5) * .3, col: cols[Math.floor(Math.random() * cols.length)] });
    var t0 = performance.now();
    function step(t) {
      var k = (t - t0) / 1800; ctx.clearRect(0, 0, c.width, c.height); if (k >= 1) return;
      ps.forEach(function (p) { p.vy += .35; p.vx *= .99; p.x += p.vx; p.y += p.vy; p.a += p.va; ctx.save(); ctx.globalAlpha = Math.max(0, 1 - Math.max(0, k - .6) / .4); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.fillStyle = p.col; ctx.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2); ctx.restore(); });
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var started = false;
  function start() {
    if (started || !window.KBRecs) return; started = true;
    document.querySelectorAll('[data-kb-routine]').forEach(initRoutine);
    document.querySelectorAll('[data-kb-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-kb-months]').forEach(initMonths);
    initTiers();
  }
  document.addEventListener('kb:ready', start);
  if (window.KBTrack && window.KBTrack.consent() !== null) start();
  setTimeout(start, 1000);
  // Theme-editor: secties die worden aangezet of toegevoegd komen live in de pagina; die hier alsnog starten.
  document.addEventListener('shopify:section:load', function (e) {
    if (!started || !window.KBRecs || !e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-kb-routine]').forEach(initRoutine);
    e.target.querySelectorAll('[data-kb-tabs]').forEach(initTabs);
    e.target.querySelectorAll('[data-kb-months]').forEach(initMonths);
  });
  window.KBSections = { confetti: confetti };
})();
